import { Stack, Typography } from '@mui/material';

export const WisdomChatListEmptyState = () => {
  return (
    <Stack alignItems="center" justifyContent="center">
      <Typography variant="h3">📂</Typography>
      <Stack alignItems="center" justifyContent="center">
        <Typography variant="caption" color="text.secondary">
          No chats created yet
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          mt={2}
          textAlign="center"
        >
          The journey to Wisdom begins with a single conversation. Let's get
          started!
        </Typography>
      </Stack>
    </Stack>
  );
};
